import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import './EmailForm.css';
import {sendEmailForOTP} from '../../../api/forgetpasswordApi/forgetpasswordApi';
import { OTPForm } from '../OTP Form/OTPForm';

export const EmailForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  // Handle email input change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Simple email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email.");
      toast.error("Please enter a valid email.");
      return;
    }

    try {
      localStorage.setItem("email", email);
      // console.log("Meka balapn: ", localStorage.getItem("email"));
      // Call the API to send OTP
      await sendEmailForOTP(email);
      toast.success("OTP has been sent to your email!");
      setOpen(true); 
    } catch (error) {
      console.error("Error sending OTP:", error);
      setError("Failed to send OTP. Please try again. (Enter your )");
      toast.error("Failed to send OTP. Please try again."); 
    }
  };

  return (
    <div>
      <Box className="EmailFormBox">
        <form className="EmailForm-Form" onSubmit={handleSubmit}>
          <h2 className="EmailFormHeader">Forgot Your Password?</h2>

          {/* Email input field */}
          <TextField
            type="email"
            placeholder="Enter Email"
            className="EmailFormInputFeild"
            value={email}
            onChange={handleEmailChange}
            error={!!error}
            helperText={error}
            fullWidth
            margin="normal"
            size="small"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
          sx={{
             
              backgroundColor: "#6E0506 !important",
              "&:hover": {
                backgroundColor: "#6E0506 !important",
              },
              "&.Mui-disabled": {
                backgroundColor: "#E54447 !important",
                color: "#fff",
              },
              color: "#fff",
              textTransform: 'none',
              borderRadius: '10px !important',
            }}
            className="EmailFormButton"
          >
            Send Email
          </Button>

          <span onClick={() => navigate('/')} className="EmailFormLink">
            Actually, I remember it
          </span>
        </form>
      </Box>

      {/*  ToastContainer  */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <OTPForm open={open} handleClose={() => setOpen(false)} email={email} />
    </div>
  );
};
